import * as React from "react";

function SvgBottom(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M3 15.1h14v2H3zM9.4 2.9h1.2v8.6l1.3-1.3 1.1.8-3 3-3-3 1.1-.8 1.3 1.3V2.9z" /></svg>;
}

export default SvgBottom;